import {
  GET_USERDASHBOARD_SUCCESS,
  GET_USERDASHBOARD_FAIL,
  GET_REPORTDASHBOARD_SUCCESS,
  GET_REPORTDASHBOARD_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  userDashboardData: '',
  reportDashboardData:'',
}

const userDashboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USERDASHBOARD_SUCCESS:
      return {
        ...state,
        userDashboardData: action.payload,
      }

    case GET_USERDASHBOARD_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      case GET_REPORTDASHBOARD_SUCCESS:
        return {
          ...state,
          reportDashboardData: action.payload,
        }
  
      case GET_REPORTDASHBOARD_FAIL:
        return {
          ...state,
          error: action.payload,
        }
  
    default:
      return state
  }
}

export default userDashboard
